import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CTABand() {
  return (
    <section data-testid="cta-band" className="bg-signal text-black">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.25em] uppercase mb-6 text-black/60">
            Ready when you are
          </p>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-none max-w-3xl">
              Have an installation or rollout project? Tell us what you need.
            </h2>
            <Link
              to="/contact"
              data-testid="cta-band-button"
              className="group inline-flex shrink-0 items-center gap-3 bg-black text-white font-mono text-xs font-bold tracking-[0.15em] uppercase px-8 py-5 hover:-translate-y-1 transition-transform duration-300"
            >
              Discuss Your Project
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
